import { ViewModel,View } from "binder"
import  { ReportSelectionView } from "./reportSelection-view"
import { IStaticValueProvider } from "src/formBuilder/formBuilder/templateEditor/propertiesPanel/editors/IStaticValueProvider";
import { ReportSelectonPopupViewModel } from "./reportSelectionPopup/reportSelectonPopup-viewModel";

export class ReportSelectionViewModel extends ViewModel implements IStaticValueProvider{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ReportSelectionView();
    }
    public getTypeId(): string {
        return "VM-524FB5AB-FBFD-4C29-900B-AA41AC0327AB"
    }

    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;

    async edit(){
        let editor = new ReportSelectonPopupViewModel(this);
        editor.load(this.value);
        let result = await this.requestShowingPopup(editor);
        if(result!=null && result!=false){
            this.value = result;
            this.requestConfirm();
        }
    }
    setValue(v: string) {
        this.value = v;
    }
    getValue(): string {
        return this.value;
    }
    requestConfirm() {
    }

}
